import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39.353 13.959a5 5 0 0 1-4.313-4.322L34 10.659V11a4 4 0 0 0 4 4h.337zm-2.797 2.866a6.01 6.01 0 0 1-4.379-4.373l-8.052 7.92a1 1 0 0 0-.125.149V21a4 4 0 0 0 4 4h.5q.036 0 .073.003l.05-.049zM25.09 26.25a6.03 6.03 0 0 1-2.309-2.285L21.6 27.413zm11.291-20.7a5 5 0 1 1 7.02 7.116 1 1 0 0 1-.076.085l-13.27 13.6a3 3 0 0 1-1.199.75l-6.623 2.208a2 2 0 0 1-2.524-2.546l2.279-6.652c.15-.44.402-.84.734-1.167L36.198 5.693q.084-.083.182-.142M43 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-3 11a1 1 0 1 1 2 0v5.966q0 5.204-.388 10.35a9 9 0 0 1-8.298 8.297A137 137 0 0 1 23 45q-5.19 0-10.32-.387a9 9 0 0 1-8.298-8.298Q4 31.245 4 26.069q0-5.22.389-10.384a9 9 0 0 1 8.298-8.298Q17.814 7 23 7h6a1 1 0 1 1 0 2h-6q-5.11 0-10.163.381a7 7 0 0 0-6.454 6.454 136 136 0 0 0-.006 20.33 7 7 0 0 0 6.453 6.453Q17.885 43 23 43q5.11 0 10.164-.381a7 7 0 0 0 6.454-6.454q.382-5.07.382-10.2z",
      clipRule: "evenodd"
    }
  )
);
var SvgNotesOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var NotesOutlined_default = SvgNotesOutlined;

export { NotesOutlined_default as default };
